var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlannerReviewActive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_257_11",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_257_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.2 16L7.85 3.75C7.9 3.51667 8.0125 3.33333 8.1875 3.2C8.3625 3.06667 8.56667 3 8.8 3H9.225C9.45833 3 9.6625 3.07083 9.8375 3.2125C10.0125 3.35417 10.125 3.54167 10.175 3.775L13.05 17.3L14.825 9.75C14.875 9.53333 14.9875 9.35417 15.1625 9.2125C15.3375 9.07083 15.5417 9 15.775 9H16.25C16.4833 9 16.6833 9.06667 16.85 9.2C17.0167 9.33333 17.125 9.50833 17.175 9.725L18.8 16H21C21.2833 16 21.5208 16.0958 21.7125 16.2875C21.9042 16.4792 22 16.7167 22 17C22 17.2833 21.9042 17.5208 21.7125 17.7125C21.5208 17.9042 21.2833 18 21 18H18.025C17.7917 18 17.5875 17.9333 17.4125 17.8C17.2375 17.6667 17.1167 17.4833 17.05 17.25L16.05 13.3L14.175 21.25C14.125 21.4833 14.0125 21.6667 13.8375 21.8C13.6625 21.9333 13.4583 22 13.225 22H12.8C12.5667 22 12.3583 21.9292 12.175 21.7875C11.9917 21.6458 11.875 21.4583 11.825 21.225L9 7.95L6.975 17.225C6.925 17.4583 6.80833 17.6458 6.625 17.7875C6.44167 17.9292 6.23333 18 6 18H3C2.71667 18 2.47917 17.9042 2.2875 17.7125C2.09583 17.5208 2 17.2833 2 17C2 16.7167 2.09583 16.4792 2.2875 16.2875C2.47917 16.0958 2.71667 16 3 16H5.2Z",
    fill: "#4BD7D1"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlannerReviewActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/planner_review-active.fcf95293900edfdab21a4941da8e8974.svg";